import { render, staticRenderFns } from "./sortData.vue?vue&type=template&id=4bb42255&scoped=true&"
import script from "./sortData.vue?vue&type=script&lang=js&"
export * from "./sortData.vue?vue&type=script&lang=js&"
import style0 from "./sortData.vue?vue&type=style&index=0&id=4bb42255&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb42255",
  null
  
)

export default component.exports